import styled from "styled-components";

export const DocumentCardContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	padding: 16px;
	border: 1px solid #e2e8f0;
	border-radius: 10px;
`;

export const DocumentCardLeftContentContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	flex: 1;
	min-width: 0;
`;

export const DocumentCardIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 20px;
	height: 20px;
`;

export const DocumentCardContentContainer = styled.div`
	display: flex;
	flex-direction: column;

	> p {
		margin: 0;
		font-size: 12px;
		line-height: 23px;
		color: #9f9fa9;
	}
`;

export const DocumentCardFileNumberContainer = styled(
	DocumentCardLeftContentContainer
)`
	gap: 8px;

	p:first-child {
		font-size: 14px;
		font-weight: 500;
		line-height: 23px;
		color: #31475a;
	}

	p:last-child {
		font-size: 12px;
		line-height: 23px;
		color: #62748e;
		margin: 0;
	}
`;

export const DocumentCardRightContentContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;

	button {
		background: transparent;
		border: none;
		cursor: pointer;
		padding: 0;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
